import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// eslint-disable-next-line camelcase,max-classes-per-file
import Cookies from 'js-cookie';
import DeviceBaseInfo from './DeviceBaseInfo';

var DeviceInfo = /*#__PURE__*/function (_DeviceBaseInfo) {
  _inherits(DeviceInfo, _DeviceBaseInfo);

  var _super = _createSuper(DeviceInfo);

  function DeviceInfo() {
    var _this;

    _classCallCheck(this, DeviceInfo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getInfo", function (callback, hybridId) {
      var deviceInfo = new DeviceBaseInfo();
      getInfoFromCookie(function (touchInfo) {
        var info = Object.assign(deviceInfo, touchInfo);
        callback(info);
      });
    });

    return _this;
  }

  return DeviceInfo;
}(DeviceBaseInfo);

export default new DeviceInfo();
/**
 * 通过cookie获取uuid、uid等信息
 * @param callback 回调方法返回信息
 */

var getInfoFromCookie = function getInfoFromCookie(callback) {
  var ret = {};
  var cookiesObj = Cookies.get();
  ret.uid = cookiesObj.QN48;
  ret.uuid = cookiesObj._s;
  callback(ret);
};